import {lazy, Suspense} from 'react';

const LazyPropertyEstimateTooltip = lazy(() => import('./PropertyEstimateTooltip'));

const FallbackComponent = () => null;

const PropertyEstimateTooltip = props => (
  <Suspense fallback={<FallbackComponent {...props} />}>
    <LazyPropertyEstimateTooltip {...props} />
  </Suspense>
);

export default PropertyEstimateTooltip;
